import React from "react";
import { RegisterOptions } from "react-hook-form";
import { StateField, FormItem } from "..";
import { StateControlProps } from "./StateControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function StateControl(props: StateControlProps) {
  const {
    defaultValue,
    getStateFieldProps,
    hideHelperText,
    label,
    maxLength,
    name,
    required,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {};
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    if (maxLength !== undefined) {
      result.maxLength = {
        value: maxLength,
        message: `The maximum number of characters is ${maxLength}`,
      };
    }
    return result;
  }, [label, maxLength, required]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getStateFieldProps?.(params);
    },
    [getStateFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      rules={rules}
      valuePropName={valuePropName}
    >
      <StateField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(StateControl);
